/** Picks a random element from an array. */
export function pickRand<T extends Array<unknown> | string>(arr: T): T[number] {
  return arr[Math.floor(Math.random() * arr.length)]
}
